import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from '@utils';
import App from '@app';
import { Spin } from '@components';
import { setInfoUsuario } from '@ducks/login';

export default function Redirect({ history }) {
  const { user, url } = useSearchParams();
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      dispatch(setInfoUsuario(JSON.parse(user)));
      history.replace(url);
    } catch (err) {
      Notification.error('Erro ao redirecionar ' + err.message);
    }
  });

  return (
    <Spin>
      <App />
    </Spin>
  );
}
